'use client';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface BlogContentProps {
  content: string;
}

export default function BlogContent({ content }: BlogContentProps) {
  return (
    <div className="prose dark:prose-invert prose-base md:prose-lg max-w-none prose-headings:font-mono prose-headings:font-bold prose-headings:tracking-tight prose-headings:text-slate-900 dark:prose-headings:text-white prose-a:text-purple-600 dark:prose-a:text-purple-400 prose-a:no-underline hover:prose-a:underline prose-p:text-slate-700 dark:prose-p:text-slate-300 prose-li:text-slate-700 dark:prose-li:text-slate-300 prose-pre:bg-slate-900 dark:prose-pre:bg-black/60 prose-pre:border prose-pre:border-slate-800 dark:prose-pre:border-white/10 prose-pre:rounded-xl prose-pre:overflow-x-auto prose-pre:p-5 prose-pre:text-sm prose-pre:leading-relaxed prose-code:font-mono prose-code:text-sm prose-strong:text-slate-900 dark:prose-strong:text-white prose-hr:border-slate-200 dark:prose-hr:border-white/10 prose-table:w-full prose-thead:bg-slate-100 dark:prose-thead:bg-white/5 prose-th:font-mono prose-th:text-left prose-th:px-4 prose-th:py-2 prose-th:text-slate-900 dark:prose-th:text-white prose-td:px-4 prose-td:py-2 prose-td:border-b prose-td:border-slate-200 dark:prose-td:border-white/10 prose-blockquote:not-italic prose-blockquote:font-normal prose-blockquote:border-purple-500 prose-blockquote:bg-purple-50/60 dark:prose-blockquote:bg-purple-500/10 prose-blockquote:rounded-r-lg prose-blockquote:py-1 prose-blockquote:pr-4 [&_blockquote_p]:before:content-none [&_blockquote_p]:after:content-none">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // Wide pricing tables scroll inside their own box instead of the whole page on mobile.
          table: ({ node, ...props }) => (
            <div className="overflow-x-auto">
              <table {...props} />
            </div>
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
